import { render } from "./PublicStageView.vue?vue&type=template&id=1b30960c&scoped=true&ts=true"
import script from "./PublicStageView.ts?vue&type=script&lang=ts"
export * from "./PublicStageView.ts?vue&type=script&lang=ts"

import "./PublicStageView.scss?vue&type=style&index=0&id=1b30960c&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b30960c"]])

export default __exports__